import { FETCH_LAB } from "./index";

export const setLabDataState = (payload) => {
  return {
    type: FETCH_LAB,
    payload: payload,
  };
};
